import { Content } from "antd/es/layout/layout";
import AddsNAv from "../../../components/common/addsNav";
import { Layout } from "antd";
import { Outlet } from "react-router";

const Ads = () => {
  return (
    <div>
      <Layout className="bg-white">
        <AddsNAv />
        <Layout>
          <Content className="w-full overflow-auto bg-white over">
            <div className=" bg-white">
              <Outlet />
            </div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};
export default Ads;
